import React, { Component } from 'react';
import PageBanner from '../components/PageBanner';
import Footer from '../components/Footer';
class Privacy extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
    const existing = document.getElementById('termly-jssdk');
    if (existing) existing.remove();
    const script = document.createElement('script');
    script.id = 'termly-jssdk';
    script.src = 'https://app.termly.io/embed-policy.min.js';
    document.body.appendChild(script);
  }
  render() {
    return (
      <div>
        <PageBanner title='Privacy Policy' background='page-banner.jpg' />
        <div className='p-3'>
          <div
            name='termly-embed'
            data-id='177e7153-7f9b-4777-83fd-ef9d48ec6a44'
          ></div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default Privacy;
